import type { AuthState } from "@/data/types/auth";

export const AUTH_INIT_TIMEOUT_MS = 5000;

export const INITIAL_STATE: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  user: null,
  tokens: null,
  error: null,
};
